class RetryUploadHandler {
  constructor() {
    this.interval = 1000; // One second
    this.maxInterval = 60 * 1000; // One minute
  }

  retry(fn) {
    setTimeout(fn, this.interval);
    this.interval = this.nextInterval();
  }

  reset() {
    this.interval = 1000;
  }

  nextInterval() {
    const interval = this.interval * 2 + this.getRandomInt(0, 1000);
    return Math.min(interval, this.maxInterval);
  }

  getRandomInt(min, max) {
    return Math.floor(Math.random() * (max - min + 1) + min);
  }
}

class Uploader {
  constructor(options) {
    const noop = () => {};
    this.file = options.file;
    this.contentType =
      options.contentType || this.file.type || 'application/octet-stream';
    this.metadata = options.metadata || {
      name: this.file.name,
      mimeType: this.contentType,
    };
    this.onComplete = options.onComplete || noop;
    this.onProgress = options.onProgress || noop;
    this.onError = options.onError || noop;
    this.onAbort = options.onAbort || noop;
    this.retryUploadHandler = new RetryUploadHandler();

    this.url = options.url;
    this.fileXhrRequest = new XMLHttpRequest();
  }

  sendFile() {
    this.fileXhrRequest.open('PUT', this.url, true);
    this.fileXhrRequest.setRequestHeader('Content-Type', this.contentType);
    this.fileXhrRequest.setRequestHeader(
      'X-Upload-Content-Type',
      this.file.type,
    );

    if (this.fileXhrRequest.upload) {
      this.fileXhrRequest.upload.addEventListener('progress', this.onProgress);
      this.fileXhrRequest.upload.addEventListener('abort', this.onAbort);
    }

    this.fileXhrRequest.onload = this.onContentUploadSuccess.bind(this);
    this.fileXhrRequest.onerror = this.onContentUploadError.bind(this);
    this.fileXhrRequest.send(this.file);
  }

  onContentUploadSuccess(e) {
    if (e.target.status === 200 || e.target.status === 201) {
      this.onComplete(e.target.response);
    } else {
      this.onContentUploadError(e);
    }
  }

  onContentUploadError(e) {
    if (e.target.status && e.target.status < 500) {
      this.onError(e.target.response);
    } else {
      // Retry by re-uploading the file body on a FRESH XHR. Reusing the
      // existing XHR across retries leaks `progress` / `abort` listeners on
      // `xhr.upload` (these accumulate; `xhr.open()` doesn't clear them) and
      // risks carrying half-aborted internal state into the next attempt.
      this.fileXhrRequest = new XMLHttpRequest();
      this.retryUploadHandler.retry(this.sendFile.bind(this));
    }
  }

  onUploadError(e) {
    this.onError(e.target.response);
  }
}

export default Uploader;
